import TokenResource from "./TokenResource";

export default class ConsentResource extends TokenResource {
	label = "";
	id = "";
	description = "";
	consented = false;

	pk() {
		return this.id ? this.id.toString() : "static";
	}

	/** will suspend when data is stale even if it already exists in cache */
	static getRequestOptions() {
		return {
			invalidIfStale: true,
		};
	}

	static urlRoot = "/api/consents";
}
